// extracted by mini-css-extract-plugin
export default {"group-meal-tag":"RJlmm_group-meal-tag","group-meal-icon":"YZ5VB_group-meal-icon","group-meal-text":"hCRje_group-meal-text"};